import React, { useEffect, useState } from "react";
import { useRef } from "react";
//------------------Third Party library-----------------------
import DatePicker from "react-datepicker";
import {
  Editor,
  BtnBold,
  BtnItalic,
  BtnRedo,
  BtnStrikeThrough,
  BtnUnderline,
  BtnUndo,
  EditorProvider,
  Toolbar,
  Separator,
  BtnNumberedList,
  BtnBulletList,
  BtnClearFormatting,
  HtmlButton,
  BtnStyles,
  // subStatusList,
  // setSubStatusList
} from "react-simple-wysiwyg";
import moment from "moment";
//------------------Api handler-----------------------
import AllianceManagerServices from "../../../services/API/AllianceManager";
import { toast } from "react-toastify";
import { format } from "date-fns";
import "../../../styles/alliance-manager/datepicker.css";
import useAuth from "../../../hooks/useAuth";
const StatutoryFeeUpdateStatus = ({
  licenseStatus,
  setLicenseStatus,
  licenseStatusErrors,
  setCourierDetails,
  setPaymentDetails,
  setCourierDetailsErrors,
  setPaymentDetailsErrors,
  initialCourierDetails,
  initialPaymentDetails,
  updateStatus,
  setFlag,
  flag,
  srnStatues,
  details,
  eligible, //27-08-2024 - p1:status matrix update - Subha
  setSubStatusList,
  subStatusList,
  srnActivity,
  isStatutoryFee,
  roleId
}) => {
  const auth = useAuth();
  
  const [statusList, setStatusList] = useState([]);
  // const [subStatusList, setSubStatusList] = useState([]);
  const [editorText, setEditorText] = useState();

  const [data, setData] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    if(details){ 
      getFieldsData({executiveId:details?.executive_id,fieldExecutive:details?.field_executive_id});
      if (details?.get_srn_statustes?.renewal_date) {
        setData(details?.get_srn_statustes?.renewal_date);
      }
      setLicenseStatus({
        ...licenseStatus,
        status: details?.get_srn_statustes?.status,
      });
    }  
  }, [details]);
  const getFieldsData = async (execFieldExec) => {
    try {
      const statusListRes = await AllianceManagerServices.getStatusList();
      // const subStatusListRes = await AllianceManagerServices.getSubStatusList();
      if (statusListRes.status == "success"){
        let result = statusListRes?.data
        let filtered = []
        if(srnActivity?.length){
          if(srnActivity[0]?.length){
            filtered = srnActivity[0][0]?.filter((item)=>item.status == "Submitted to Authority")
          }
        }
        if(filtered?.length && filtered[0]?.created_at){
          const createdAt = new Date(filtered[0].created_at);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (filtered.length && !(createdAt < today)) {
            result = result?.filter(item => item?.name !== "Closed" && item?.name !== "Completed");
           }
        }else{
          result = result?.filter(item => item?.name !== "Closed" && item?.name !== "Completed");
        }
        if(!details.is_statutory_fee){
          result = result?.filter(item => item?.name.toLowerCase() !== "payment request");
        }

        //18-12-2024 - removed status filter based on requirement - Subha
        // if(execFieldExec?.executiveId || execFieldExec?.fieldExecutive){
        //    if(auth?.roleId != 2 && auth?.roleId != 3){
        //      result = result?.filter((item)=>item?.name != "Submitted to Authority")
        //    }
           
        // }else{
        //   result = result?.filter((item)=>item?.name != "Submitted to Authority")
        // } 
        setStatusList(result)

        // if(execFieldExec?.executiveId || execFieldExec?.fieldExecutive){
        //   const result = statusListRes?.data?.filter((item)=>item?.name != "Submitted to Authority")
        //   setStatusList(result);
        // }else{
        //   setStatusList(statusListRes?.data);
        // }
      }
      // if (subStatusListRes.status === "success")
      //   setSubStatusList(subStatusListRes?.data);
    } catch (error) {
      toast.error("Something went wrong, try again later.");
    }
  };

  return (
    <div className="card card-sm card-shadow">
      <div className="card-body">
        <h3 className="mb-3">Statutory Fee :</h3>
        <h4 className="mb-5">
            {"Amount: INR " + details?.statutory_fee}
        </h4>
        <h4 className="mb-5">
            {details?.statutory_fee_remark && "Remark: " + details?.statutory_fee_remark}
        </h4>
        <section>
          <div className="mb-3">
            <label className="label">
              Amount (In INR)
            </label>
            <label className="input">
              <input
                type="number"
                className="input-sm"
                placeholder="Amount (In INR)"
                value={licenseStatus.statutory_fee}
                onChange={(e) => {
                  setLicenseStatus({
                    ...licenseStatus,
                    statutory_fee: e.target.value,
                  });
                }}
              />
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                }}
              >
                {licenseStatusErrors.statutory_fee}
              </p>
            </label>
          </div>
        </section>
        <div className="d-flex justify-content-end pt-10">
          <button
            style={{ background: "green", color: "white" }}
            className="btn button_new"
            onClick={() => {
              updateStatus();
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatutoryFeeUpdateStatus;
